import { useEffect, useState } from "react";
import {
  Autocomplete,
  DatePicker,
  FormControl,
  Grid,
  Loading,
  MenuItem,
  Select,
  TextField,
} from "../../../../components";
import { AtivoServicoService, PessoaService } from "../../../../services";
import { responseErros } from "../../../../utils";

const FormFiltroAvancado = ({
  valueInput,
  onChangeInput,
  valueDate,
  onChangeDate,
  valueAutocomplete,
  onChangeAutocomplete,
}) => {
  const pessoaService = new PessoaService();
  const ativoServicoService = new AtivoServicoService();
  const [loading, setLoading] = useState(false);
  const [clienteList, setClienteList] = useState([]);
  const [ativoList, setAtivoList] = useState([]);

  useEffect(() => {
    buscarClientes();
    buscarAtivos();
  }, []);

  const buscarClientes = () => {
    const filtros = {
      nonPaginated: true,
      tiposPessoaId: 1,
      attributes: ["id", "nomeRazaoSocial"],
    };
    setLoading(true);
    pessoaService.getAll(filtros).then((result) => {
      setLoading(false);
      if (!result.isAxiosError) {
        setClienteList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarAtivos = () => {
    ativoServicoService.getAll().then((result) => {
      if (!result.isAxiosError) {
        const ativosComCampoChave = (result.data || []).filter(
          (ativo) =>
            ativo?.ativado &&
            ativo?.camposPersonalizados?.some((campo) => campo.campoChave),
        );
        setAtivoList(ativosComCampoChave);
      } else {
        responseErros(result);
      }
    });
  };

  const ativoSelecionado = valueAutocomplete(ativoList, "ativoId");

  const campoChaveAtivo = ativoSelecionado?.camposPersonalizados?.find(
    (campo) => campo.campoChave,
  );

  // const buscarStatusPersonalizados = async function () {
  //   setLoading(true);
  //   const result = await ordemServicosStatusPersonalizadosService.getAll();
  //   if (!result.isAxiosError) {
  //     const colunasCompletas = [
  //       { id: "ABERTO", descricao: "ABERTO", cor: "#4FBB53" },
  //       ...result.data,
  //       { id: "FECHADO", descricao: "FECHADO", cor: "#004780" },
  //     ];
  //     const statusListCompleto = colunasCompletas.map((col) => ({
  //       ...col,
  //       status: col.descricao,
  //     }));
  //     setStatusList(statusListCompleto);
  //   } else {
  //     responseErros(result);
  //   }
  //   setLoading(false);
  // };

  // const statusSelecionados = statusList.filter((s) => {
  //   if (s.id === "ABERTO" || s.id === "FECHADO") {
  //     return valueInput("status")?.includes(s.id);
  //   }
  //   return valueInput("statusPersonalizadoId")?.includes(s.id);
  // });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          id="numeroDocumento"
          name="numeroDocumento"
          label="Nº Documento"
          variant="outlined"
          margin="none"
          fullWidth
          onChange={(event) => onChangeInput(event)}
          value={valueInput("numeroDocumento")}
        />
      </Grid>

      <Grid item xs={12}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="clienteId"
            name="clienteId"
            options={clienteList}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
            getOptionSelected={(option, value) =>
              option?.nomeRazaoSocial === value?.nomeRazaoSocial
            }
            renderInput={(params) => (
              <TextField {...params} label="Cliente" variant="outlined" />
            )}
            onChange={(e, value) => onChangeAutocomplete("clienteId", value)}
            value={valueAutocomplete(clienteList, "clienteId")}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataAberturaStart"
          name="dataAberturaStart"
          label="Data Abertura De"
          format="dd/MM/yyyy"
          value={valueDate("dataAberturaStart")}
          onChange={(date) => onChangeDate("dataAberturaStart", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataAberturaEnd"
          name="dataAberturaEnd"
          label="Data Abertura Até"
          format="dd/MM/yyyy"
          value={valueDate("dataAberturaEnd")}
          onChange={(date) => onChangeDate("dataAberturaEnd", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataPrevistaFechamentoStart"
          name="dataPrevistaFechamentoStart"
          label="Data Fechamento De"
          format="dd/MM/yyyy"
          value={valueDate("dataPrevistaFechamentoStart")}
          onChange={(date) => onChangeDate("dataPrevistaFechamentoStart", date)}
        />
      </Grid>
      <Grid item xs={6}>
        <DatePicker
          id="dataPrevistaFechamentoEnd"
          name="dataPrevistaFechamentoEnd"
          label="Data Fechamento Até"
          format="dd/MM/yyyy"
          value={valueDate("dataPrevistaFechamentoEnd")}
          onChange={(date) => onChangeDate("dataPrevistaFechamentoEnd", date)}
        />
      </Grid>
      {ativoList.length > 0 && (
        <>
          <Grid item xs={6}>
            <FormControl variant="outlined" fullWidth>
              <Autocomplete
                id="ativoId"
                name="Ativo"
                options={ativoList}
                autoHighlight
                disablePortal
                getOptionLabel={(option) => option?.nome ?? ""}
                getOptionSelected={(option, value) => option?.id === value?.id}
                noOptionsText="Sem opções"
                renderInput={(params) => (
                  <TextField {...params} label="Ativo" variant="outlined" />
                )}
                onChange={(_, newValue) =>
                  onChangeAutocomplete("ativoId", newValue)
                }
                value={valueAutocomplete(ativoList, "ativoId")}
              />
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            {campoChaveAtivo?.type === "enum" ? (
              <Select
                id="ativoCampoChave"
                name="ativoCampoChave"
                label={campoChaveAtivo.label}
                fullWidth
                onChange={(event) => onChangeInput(event)}
                value={valueInput("ativoCampoChave")}
                SelectProps={{
                  MenuProps: {
                    disablePortal: true,
                    PaperProps: { sx: { zIndex: 1600 } },
                  },
                }}
              >
                <MenuItem value="">Todos</MenuItem>
                {(campoChaveAtivo.values || "")
                  .split(",")
                  .filter((item) => item)
                  .map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            ) : (
              <TextField
                id="ativoCampoChave"
                name="ativoCampoChave"
                label={campoChaveAtivo?.label || "Campo Chave"}
                variant="outlined"
                fullWidth
                disabled={!ativoSelecionado}
                onChange={(event) => onChangeInput(event)}
                value={valueInput("ativoCampoChave")}
              />
            )}
          </Grid>
        </>
      )}
      {/* <Grid item xs={12}>
        <Autocomplete
          multiple
          id="status"
          name="status"
          options={statusList}
          noOptionsText="Sem opções"
          autoHighlight
          filterSelectedOptions
          getOptionLabel={(option) => option?.status || ""}
          onChange={(_, newValue) => onChangeMultipleStatus(newValue)}
          value={statusSelecionados}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Status"
              margin="normal"
              fullWidth
            />
          )}
          renderOption={(props, option) => (
            <li {...props}>
              {option.status}
              <i
                className="ph-fill ph-circle"
                style={{ color: `${option.cor}`, marginLeft: 8 }}
              ></i>
            </li>
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                {...getTagProps({ index })}
                key={index}
                label={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {option.status}
                    <i
                      className="ph-fill ph-circle"
                      style={{ color: `${option.cor}`, marginLeft: 6 }}
                    ></i>
                  </div>
                }
              />
            ))
          }
        />
      </Grid> */}
      {/* <Grid item xs={12}>
        <FormControlLabel
          label="Com Avaliação Realizada"
          control={
            <Checkbox
              color="primary"
              name="hasPesquisas"
              checked={valueInput("hasPesquisas")}
              onChange={() => onChangeCheckbox("hasPesquisas")}
              label="Com Avaliação Realizada"
            />
          }
        />
      </Grid> */}
      <Loading loading={loading} />
    </Grid>
  );
};

export default FormFiltroAvancado;
